/* Confetti burst — three triggers:
 *   1. Hover any element matching .js-celebrate-link
 *   2. Page load: any element with [data-celebrate-on-load] (delay via [data-celebrate-delay])
 *   3. Home-page autofire on the celebrate nav link, once per session, when
 *      `window.HHCelebrateAutofire = { delay: ms }` is set before this script runs
 *
 * Visually patterned after canvas-confetti: tight upward cone, paper-shaped
 * rectangular particles tumbling in 3D, gravity-driven fall, longer hangtime.
 * Particles are appended to <body> so the nav's overflow can't clip them. */

(function () {
  // Guard against duplicate execution if the script tag is included from
  // multiple sections (header + collection banner can both pull it in).
  if (window.__hh_celebrate_loaded) return;
  window.__hh_celebrate_loaded = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var COLORS = ['#c81d2f', '#ffffff', '#1d3a8a'];
  if (window.HHCelebrateConfig && Array.isArray(window.HHCelebrateConfig.colors) && window.HHCelebrateConfig.colors.length > 0) {
    COLORS = window.HHCelebrateConfig.colors;
  }
  var PARTICLE_COUNT = 90;
  var CONE_RADIANS = Math.PI * 130 / 180;
  var THROTTLE_MS = 600;
  var SESSION_KEY = 'hh_celebrate_home_fired';
  var lastPop = 0;

  function pop(anchorEl, opts) {
    if (!anchorEl) return;
    opts = opts || {};
    var now = Date.now();
    if (!opts.skipThrottle && (now - lastPop < THROTTLE_MS)) return;
    lastPop = now;

    var rect = anchorEl.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;

    var baseAngle = -Math.PI / 2; // straight up in screen coords
    var frag = document.createDocumentFragment();
    var nodes = [];

    for (var i = 0; i < PARTICLE_COUNT; i++) {
      var t = PARTICLE_COUNT === 1 ? 0 : i / (PARTICLE_COUNT - 1);
      // Even cone distribution + small jitter for organic spread
      var angle = baseAngle + (t - 0.5) * CONE_RADIANS + (Math.random() - 0.5) * 0.25;
      var speed = 90 + Math.random() * 130;
      var vx = Math.cos(angle) * speed;
      var vy = Math.sin(angle) * speed; // negative = up

      // Apex: kept low so particles don't shoot past the header off-screen.
      // End: every particle falls the same vertical distance from its own
      // peak, so the fall rate is uniform — particles that launched higher
      // land higher. Horizontal end keeps drifting + jitter for spread.
      var peakX = vx * 0.5;
      var peakY = vy * 0.55;
      var fallDistance = 550;
      var endX = vx * 1.7 + (Math.random() - 0.5) * 60;
      var endY = peakY + fallDistance;

      // Tumble: random multi-rotation totals, mixed signs for variety
      var tumbleX = (Math.floor(Math.random() * 3) + 2) * 360 * (Math.random() < 0.5 ? -1 : 1);
      var tumbleY = (Math.floor(Math.random() * 3) + 2) * 360 * (Math.random() < 0.5 ? -1 : 1);
      var tumbleZ = (Math.floor(Math.random() * 2) + 1) * 360 * (Math.random() < 0.5 ? -1 : 1);

      var width = 4 + Math.random() * 4;
      var height = width * (1.2 + Math.random() * 0.6); // slight rectangle, paper-strip feel
      var color = COLORS[Math.floor(Math.random() * COLORS.length)];
      // Base 300ms so the jiggle gets ~half a cycle before the burst pops.
      var delay = 300 + Math.random() * 100;

      var outer = document.createElement('span');
      outer.className = 'celebrate-particle';
      outer.style.left = cx + 'px';
      outer.style.top = cy + 'px';
      outer.style.setProperty('--celebrate-peak-x', peakX + 'px');
      outer.style.setProperty('--celebrate-peak-y', peakY + 'px');
      outer.style.setProperty('--celebrate-end-x', endX + 'px');
      outer.style.setProperty('--celebrate-end-y', endY + 'px');
      outer.style.setProperty('--celebrate-delay', delay + 'ms');

      var inner = document.createElement('span');
      inner.className = 'celebrate-particle__inner';
      inner.style.setProperty('--celebrate-w', width + 'px');
      inner.style.setProperty('--celebrate-h', height + 'px');
      inner.style.setProperty('--celebrate-color', color);
      inner.style.setProperty('--celebrate-tumble-x', tumbleX + 'deg');
      inner.style.setProperty('--celebrate-tumble-y', tumbleY + 'deg');
      inner.style.setProperty('--celebrate-tumble-z', tumbleZ + 'deg');

      outer.appendChild(inner);
      frag.appendChild(outer);
      nodes.push(outer);
    }

    document.body.appendChild(frag);
    setTimeout(function () {
      for (var i = 0; i < nodes.length; i++) nodes[i].remove();
    }, 2800);
  }

  function onEnter(e) {
    var li = e.target && e.target.closest && e.target.closest('.js-celebrate-link');
    if (!li) return;
    var anchor = li.querySelector('a') || li;
    pop(anchor);
  }

  document.addEventListener('mouseenter', onEnter, true);

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // 1) Page-load triggers — any element flagged with data-celebrate-on-load
    var loadEls = document.querySelectorAll('[data-celebrate-on-load]');
    for (var i = 0; i < loadEls.length; i++) {
      (function (el) {
        var delay = parseInt(el.getAttribute('data-celebrate-delay'), 10);
        if (isNaN(delay) || delay < 0) delay = 1000;
        setTimeout(function () { pop(el, { skipThrottle: true }); }, delay);
      })(loadEls[i]);
    }

    // 1b) Collection-page heading fire — bridges from header.liquid when the
    // current collection matches the celebrate setting. Selects the first h1
    // inside <main> so it works regardless of which section renders it.
    if (window.HHCelebrateCollection) {
      var heading = document.querySelector('#main-content h1, main h1, [role="main"] h1');
      if (heading) {
        var collDelay = parseInt(window.HHCelebrateCollection.delay, 10);
        if (isNaN(collDelay) || collDelay < 0) collDelay = 1000;
        setTimeout(function () { pop(heading, { skipThrottle: true }); }, collDelay);
      }
    }

    // 2) Home-page autofire on the celebrate nav link — once per session.
    // Trigger the jiggle alongside the pop so the link shakes the same way
    // it does on hover (the :hover-only animation doesn't fire here).
    if (window.HHCelebrateAutofire) {
      var fireOnce = function () {
        try {
          if (sessionStorage.getItem(SESSION_KEY)) return;
        } catch (e) { /* private mode — fall through and fire anyway */ }

        var navLink = document.querySelector('.js-celebrate-link a, .navigation__menulink--celebrate');
        if (!navLink) return;

        var delay = parseInt(window.HHCelebrateAutofire.delay, 10);
        if (isNaN(delay) || delay < 0) delay = 1000;

        setTimeout(function () {
          try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* ignore */ }
          navLink.classList.add('is-celebrating');
          setTimeout(function () { navLink.classList.remove('is-celebrating'); }, 700);
          pop(navLink, { skipThrottle: true });
        }, delay);
      };
      fireOnce();
    }
  });

  window.HHCelebrate = { pop: pop };
})();
